
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.446 2.667c.783 0 1.42.62 1.42 1.384v16.43c0 .765-.637 1.386-1.42 1.386H4.083c-.782 0-1.416-.621-1.416-1.386V4.051c0-.765.634-1.384 1.416-1.384h16.363zM6.938 5.31a1.65 1.65 0 10-.004 3.301 1.65 1.65 0 00.004-3.301zM5.51 19.027h2.851V9.865h-2.85v9.162zm4.637-9.162v9.162h2.845v-4.532c0-1.195.226-2.353 1.708-2.353 1.461 0 1.48 1.367 1.48 2.43v4.455h2.847v-5.025c0-2.468-.533-4.365-3.417-4.365-1.385 0-2.314.76-2.694 1.48h-.04V9.865h-2.729z"}})])
          )
        }
      }
    